import React from "react";
import { Container, Table } from "react-bootstrap";

const InvestorGrievanceTable = () => {
  const contactDetails = [
    {
      type: "Customer care",
      name: "Gian Singh",
      address: "E-24, Preet Vihar, Delhi-110092",
      contactNo: "0-9599194534",
      email: "opgdelhi@opgsecurities.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Head of Customer care",
      name: "Gian Singh",
      address: "E-24, Preet Vihar, Delhi-110092",
      contactNo: "0-9599194534",
      email: "opgdelhi@opgsecurities.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Compliance Officer",
      name: "Gian Singh",
      address: "E-24, Preet Vihar, Delhi-110092",
      contactNo: "0-9599194534",
      email: "Compliance@opgsecurities.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Director",
      name: "Om Prakash Gupta",
      address: "E-24, Preet Vihar, Delhi-110092",
      contactNo: "0-9599194544",
      email: "opg@opgsecurities.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
  ];

  return (
    <>
      <Container className="investroGrievance paragraphforall">
        <div className="EscalationTableContainer">
        <Table spellCheck frame draggable striped bordered hover className="scrollOnSmall">
          <thead>
            <tr>
              <th>#</th>
              <th>Contact Type</th>
              <th>Contact Name</th>
              <th>Address</th>
              <th>Contact No.</th>
              <th>Email</th>
              <th>Working Hours</th>
            </tr>
          </thead>
          <tbody>
            {contactDetails.map((contact, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{contact.type}</td>
                <td>{contact.name}</td>
                <td>{contact.address}</td>
                <td>{contact.contactNo}</td>
                <td>{contact.email}</td>
                <td>{contact.workingHours}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
        <p className="disc">
          In absence of response/complaint not addressed to your satisfaction,
          you may lodge a complaint with SEBI at{" "}
          <a
            href="https://scores.gov.in/scores/Welcome.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#3fb9ea" }}
          >
            https://scores.gov.in/scores/Welcome.html
          </a>{" "}
          or Exchange at{" "}
          <a
            href="https://www.msei.in/Investors/Introduction"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#3fb9ea" }}
          >
            https://www.msei.in/Investors/Introduction
          </a>
          .
        </p>
      </Container>
    </>
  );
};

export default InvestorGrievanceTable;
